import React from 'react'
import { IconButton, Tooltip, Button } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import FilterListIcon from '@mui/icons-material/FilterList'
import CompareIcon from '@mui/icons-material/Compare'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import ArticleIcon from '@mui/icons-material/Article'

const AdaptiveButton = ({
    onClick,
    buttonLabel,
    tooltipTitle,
    iconName,
    variant = 'outlined',
    isActive = false,
    forceFullButton = false,
    sx,
}) => {
    const isMobile = useMediaQuery('(max-width:600px)')
    let icon
    if (iconName === 'FilterListIcon') {
        icon = <FilterListIcon />
    } else if (iconName === 'CompareIcon') {
        icon = <CompareIcon />
    } else if (iconName === 'AutoAwesomeIcon') {
        icon = <AutoAwesomeIcon />
    } else if (iconName === 'ArticleIcon') {
        icon = <ArticleIcon />
    }
    if (isMobile && !forceFullButton)
        return (
            <Tooltip title={tooltipTitle}>
                <IconButton
                    variant={variant}
                    color="primary"
                    aria-label={tooltipTitle}
                    size="small"
                    onClick={onClick}
                    sx={{
                        my: 0,
                        ...(isActive && {
                            backgroundColor: 'primary.main',
                            color: 'common.white',
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                            },
                        }),
                        ...sx,
                    }}
                >
                    {icon}
                </IconButton>
            </Tooltip>
        )

    return (
        <Button
            onClick={onClick}
            startIcon={icon}
            color="primary"
            variant={isActive ? 'contained' : variant}
            size="small"
            sx={{
                minWidth: 120,
                my: 0,
                justifyContent: 'start',
                borderRadius: '10px',
                ...sx,
            }}
        >
            {buttonLabel}
        </Button>
    )
}
export default AdaptiveButton
